export default __webpack_public_path__ + "static/media/no-brand-tag.0b46f43d.png";